// F-25a: keeps PayPal's Pay Later message on the chosen size. Generated by payin4/storefront.mjs; do not edit here.
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var d = event && event.data;
    if (!d || !d.html) return;
    var source = d.html.getElementById('PayIn4-' + d.sectionId);
    var target = document.getElementById('PayIn4-' + d.sectionId);
    if (!source || !target) return;
    var amount = source.getAttribute('data-pp-amount');
    if (amount && target.getAttribute('data-pp-amount') !== amount) target.setAttribute('data-pp-amount', amount);
    target.classList.toggle('hidden', source.classList.contains('hidden'));
  });
})();
